module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pageCalendar",
    staticClass: "wxc-page-calendar weex-ct weex-div",
    style: (_vm._px2rem(_vm.calendarExtendStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('wxc-minibar', _vm._b({
    attrs: {
      "show": _vm.showTitle,
      "use-default-return": false,
      "data-evt-wxcMinibarLeftButtonClicked": ""
    },
    on: {
      "wxcMinibarLeftButtonClicked": _vm.minibarLeftButtonClick
    }
  }, 'wxc-minibar', _vm.minibarCfg, false)), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "calendar-weekday weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((['日', '一', '二', '三', '四', '五', '六']), function(week, k) {
    return _c('p', {
      key: k,
      staticClass: "flex-item weekday-text weex-el weex-text",
      attrs: {
        "aria-label": ("周" + week),
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(week))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('list', {
    staticClass: "calendar-list",
    attrs: {}
  }, [_vm._l((_vm.monthsArray), function(month, index) {
    return _c('section', {
      key: index,
      staticClass: " weex-ct weex-cell",
      class: [!month.title && 'calendar-row'],
      attrs: {
        "weex-type": "cell"
      }
    }, [(month.title) ? _c('p', {
      staticClass: "month-text weex-el weex-text",
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(month.title))]) : _vm._l((month), function(cell, rowIndex) {
      return _c('div', {
        key: (index + "-" + rowIndex),
        ref: cell.ref,
        refInFor: true,
        staticClass: " weex-ct weex-div",
        class: ['row-item', cell.cellClass],
        style: (cell.isSelected ? _vm._px2rem(_vm.selectedCellStyle, 75) : {}),
        attrs: {
          "accessible": true,
          "aria-label": ((cell.text?cell.text:'') + "," + (cell.note?cell.note:'') + "," + (cell.ext?cell.ext:'')),
          "weex-type": "div",
          "data-evt-click": ""
        },
        on: {
          "click": _vm.$stopOuterA,
          "weex$tap": function($event) {
            $event.stopPropagation();
            return _vm.onClickDate(cell)
          }
        }
      }, [_c('p', {
        staticClass: " weex-el weex-text",
        class: ['calendar-note', cell.cls],
        style: (cell.isSelected ? _vm._processExclusiveStyle(_vm.selectedTextStyle, 75, 'text') : {}),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(cell.note))]), _vm._v(" "), _c('p', {
        staticClass: " weex-el weex-text",
        class: ['calendar-day', cell.cls],
        style: (cell.isSelected ? _vm._processExclusiveStyle(_vm.selectedTextStyle, 75, 'text') : {}),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(cell.text))]), _vm._v(" "), _c('p', {
        staticClass: " weex-el weex-text",
        class: ['calendar-ext', cell.cls],
        style: (cell.isSelected ? _vm._processExclusiveStyle(_vm.selectedTextStyle, 75, 'text') : {}),
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(cell.ext))])])
    })], 2)
  }), _vm._v(" "), (_vm.isIPhoneX) ? _c('section', {
    staticClass: "iphone-x weex-ct weex-cell",
    attrs: {
      "weex-type": "cell"
    }
  }) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7763a75b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7763a75b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-page-calendar/index.vue
// module id = 231
// module chunks = 0 1